<template>

  <div class="padded">
    <div v-if="!fullyPaid">
    <h3>Payment</h3>

    <el-form :inline="true">
      <el-form-item label="Paid">
        <el-switch active-text="Yes" inactive-text="No"
        v-model="item.paid"
        @change="this.paidDefaults"
        :disabled="!canAccess('finance')" />
      </el-form-item>

      <el-form-item label="Amount">
        <el-input type="number" v-model="item.amountPaid" :disabled="!item.paid" />
      </el-form-item>

      <el-form-item label="Tax">
        <el-input type="number" v-model="item.taxPaid" :disabled="!item.paid" />
      </el-form-item>

      <el-form-item label="Total">
        <el-input type="number" v-model="totalPaid" disabled />
      </el-form-item>

      <el-form-item label="Date">
        <el-date-picker :format="dateFormat" v-model="item.datePaid" :disabled="!item.paid" />
      </el-form-item>

      <el-form-item label="Ref">
        <el-input autofocus v-model="item.paidRef" :disabled="!item.paid" />
      </el-form-item>

      <el-form-item>
        <el-button  type="success" @click="save()" :disabled="!item.paid" >Save</el-button>
      </el-form-item>

    </el-form>
    </div>
    <div v-else>
      <h3 style="color: seagreen;">Paid in Full
        <span v-if="rowData.datePaid">&nbsp;
          <i>{{this.formatFriendlyDate(rowData.datePaid)}}</i>
          &nbsp;({{this.formatDate(rowData.datePaid)}})&nbsp;</span>

          <span v-if="rowData.paidRef">- Ref: <strong>{{rowData.paidRef}}</strong></span></h3>
    </div>

  </div>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'

import {settings} from '@/components/Data'

export default {
  mixins: [DateMixins, PostMixins],

  props: {
    rowData: {
      type: Object,
      requried: true
    }
  },

  methods: {
    save () {
      if (this.item.datePaid) {
        this.item.datePaid = this.formatDateSql(this.item.datePaid)
      }

      this.saveForm(this, '/invoice/' + this.item.invoice_id + '/item', this.item.id, this.item,
      'Invoice Item Payment',
      this.success, this.failed, false)

    },

    success (response) {

      this.$message({
        title: 'Save Payment',
        message: 'Saved OK',
        type: 'success'
      })

//      console.log('this:', this)
//      this.$refs.invoices.refresh()

    },

    failed (response) {
      this.item.paid = false
      this.item.amountPaid = 0.00
      this.item.datePaid = null
      this.item.paidRef = null

      this.$message({
        title: 'Save Payment',
        message: '[' + response + '] failed',
        type: 'warning'
      })
    },

    paidDefaults () {

      if (this.item.paid) {

        if (!this.item.datePaid) {
          this.item.datePaid = new Date()
        }

        if (this.item.amountPaid <= 0.00) {
          this.item.amountPaid = this.item.subtotal
          this.item.taxPaid = this.item.tax
        }

      }
    }
  },

  computed: {
    totalPaid: function () {

      this.item.totalPaid = Number(this.item.amountPaid) + Number(this.item.taxPaid)

      return this.item.totalPaid
    }
  },

  data () {
    return {
      dateFormat: settings.selectDateFormat,
      fullyPaid: this.rowData.total === this.rowData.totalPaid,
      item: this.rowData
    }
  }
}
</script>



// WEBPACK FOOTER //
// ItemPaymentDetail.vue?6d03b6bf